export default __webpack_public_path__ + "static/media/landing.ilustration1.fa872acb.webp";